/* SkyEat - fast +/- stepper + sticky cart + drawer close fix */
(function () {
  'use strict';
  function post(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function qtyMap(cart) {
    var m = {};
    (cart.items || []).forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity; });
    return m;
  }
  var forms = [];
  var cartCount = 0;
  var stickyBar, stickyCountEl;

  function buildSticky() {
    stickyBar = document.getElementById('skyeat-sticky-cart');
    if (!stickyBar) {
      stickyBar = document.createElement('a');
      stickyBar.id = 'skyeat-sticky-cart';
      stickyBar.className = 'skyeat-sticky-cart';
      stickyBar.setAttribute('hidden', '');
      stickyBar.href = (window.routes && window.routes.cart_url) || '/cart';
      var left = document.createElement('span'); left.className = 'ssc-left'; left.textContent = '🛒 SkyEat Cart';
      var right = document.createElement('span'); right.className = 'ssc-btn';
      var cnt = document.createElement('span'); cnt.className = 'ssc-count'; cnt.textContent = '0 items';
      right.appendChild(cnt); right.appendChild(document.createTextNode(' • View Cart'));
      stickyBar.appendChild(left); stickyBar.appendChild(right);
      document.body.appendChild(stickyBar);
    }
    stickyCountEl = stickyBar.querySelector('.ssc-count');
  }
  function updateSticky() {
    if (!stickyBar) return;
    if (cartCount > 0) { stickyBar.removeAttribute('hidden'); if (stickyCountEl) stickyCountEl.textContent = cartCount + (cartCount === 1 ? ' item' : ' items'); }
    else { stickyBar.setAttribute('hidden', ''); }
  }

  function closeDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    if (typeof d.close === 'function') { try { d.close(); return; } catch (e) {} }
    d.classList.remove('active', 'animate');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  }
  function bindDrawerClose() {
    document.addEventListener('click', function (e) {
      var d = document.querySelector('cart-drawer');
      if (!d || !d.classList.contains('active')) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#CartDrawer-Overlay') || t.closest('.drawer__close') || t.id === 'CartDrawer-Overlay') {
        e.preventDefault(); closeDrawer();
      }
    }, true);
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeDrawer(); });
  }

  function refreshSections() {
    fetch('/?sections=cart-icon-bubble,cart-drawer').then(function (r) { return r.json(); }).then(function (d) {
      var bubble = d['cart-icon-bubble'];
      if (bubble) {
        document.querySelectorAll('#cart-icon-bubble').forEach(function (el) {
          var tmp = document.createElement('div'); tmp.innerHTML = bubble;
          var src = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild || tmp;
          el.innerHTML = src.innerHTML;
        });
      }
      var drawerHtml = d['cart-drawer'];
      if (drawerHtml) {
        document.querySelectorAll('cart-drawer').forEach(function (el) {
          var tmp = document.createElement('div'); tmp.innerHTML = drawerHtml;
          var src = tmp.querySelector('cart-drawer') || tmp.firstElementChild;
          if (src) el.innerHTML = src.innerHTML;
        });
      }
    }).catch(function () {});
  }

  function setView(f, qty) {
    var num = f.stepper.querySelector('.skqty__num'); if (num) num.textContent = qty;
    if (qty > 0) { f.stepper.style.display = 'inline-flex'; f.btn.style.display = 'none'; }
    else { f.stepper.style.display = 'none'; f.btn.style.display = ''; }
  }
  function applyMap(map) {
    cartCount = 0;
    Object.keys(map).forEach(function (k) { cartCount += map[k]; });
    forms.forEach(function (f) { setView(f, map[Number(f.variantId)] || 0); });
    updateSticky();
  }
  function localQty(f) { var n = f.stepper.querySelector('.skqty__num'); return parseInt(n ? n.textContent : '0', 10) || 0; }

  function makeStepper() {
    var s = document.createElement('div'); s.className = 'skqty'; s.style.display = 'none';
    var minus = document.createElement('button'); minus.type = 'button'; minus.className = 'skqty__btn skqty__minus'; minus.textContent = '−';
    var num = document.createElement('span'); num.className = 'skqty__num'; num.textContent = '0';
    var plus = document.createElement('button'); plus.type = 'button'; plus.className = 'skqty__btn skqty__plus'; plus.textContent = '+';
    s.appendChild(minus); s.appendChild(num); s.appendChild(plus);
    return s;
  }

  var bubbleTimer = null;
  function scheduleRefresh() { if (bubbleTimer) clearTimeout(bubbleTimer); bubbleTimer = setTimeout(refreshSections, 150); }

  function syncServer(f) {
    if (f._t) clearTimeout(f._t);
    f._t = setTimeout(function () {
      post('/cart/change.js', { id: String(f.variantId), quantity: f._pending }).then(function () { scheduleRefresh(); }).catch(function () {});
    }, 260);
  }
  function bump(f, delta) {
    var cur = localQty(f); var target = cur + delta; if (target < 0) target = 0;
    cartCount += (target - cur);
    setView(f, target); updateSticky();
    f._pending = target; syncServer(f);
  }

  function init() {
    buildSticky();
    bindDrawerClose();
    document.querySelectorAll('product-form').forEach(function (pf) {
      var input = pf.querySelector('input[name="id"]');
      var btn = pf.querySelector('.quick-add__submit');
      if (!input || !btn || !input.value) return;
      var container = btn.parentNode; var variantId = input.value;
      var stepper = makeStepper(); container.appendChild(stepper);
      var f = { btn: btn, stepper: stepper, variantId: variantId, _t: null, _pending: 0 }; forms.push(f);
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        cartCount += 1; setView(f, 1); updateSticky();
        post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] }).then(function () { scheduleRefresh(); }).catch(function () {});
      }, true);
      stepper.querySelector('.skqty__plus').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); bump(f, 1); });
      stepper.querySelector('.skqty__minus').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); bump(f, -1); });
    });
    getCart().then(function (cart) { applyMap(qtyMap(cart)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
